import React from 'react';
import { Link } from 'react-router-dom';

import RegistrationForm from 'components/registrationForm/registrationForm';
import navigationPaths from 'engine/navigationPaths';
import { OEM } from 'utility/OEMProvider';
import { resources } from 'oems/resources';

import * as Styled from './registrationPage.styles';

export const RegistrationPage = () => {
  return (
    <Styled.Wrapper>
      <img src={resources.logoDarkImage} alt="logo" className="logo" />
      <Styled.FormWrapper>
        <div className="content">
          <Styled.Title>Stwórz konto</Styled.Title>

          <p>
            Masz konto w {OEM().ProductName}? <Link to={navigationPaths().LogIn}>Zaloguj się</Link>
          </p>

          <RegistrationForm isStandalone />
        </div>

        <Styled.Copyright>{OEM().Copyright}</Styled.Copyright>
      </Styled.FormWrapper>

      <Styled.Description>
        <Styled.Title>Faktury automatyczne</Styled.Title>
        <p>Dzięki automatycznym fakturom, nie będziesz musiał pamiętać o wystawieniu dokumentów w każdym miesiącu.</p>
        <img src={resources.loginImage} alt="" />
      </Styled.Description>
    </Styled.Wrapper>
  );
};
